import { Component } from 'react';
/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
export default class Option extends Component {
}
Option.__PRO_OPTION = true;
